var render = function render(){var _vm=this,_c=_vm._self._c;return _c('legal-page-layout',{attrs:{"title":_vm.$t('legal.title'),"updated":_vm.$t('legal.updated'),"paragraphs":_vm.$t('legal.paragraphs')}})
}
var staticRenderFns = []

export { render, staticRenderFns }